module.exports = __webpack_public_path__ + "static/hsh-463378e81e3dda028536a91ba3177aaf.jpg";